// lib
import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

// components
import TransitionPanel from '@aytm/app/stats/components/transition-panel/TransitionPanel'

// styles
import style from '@aytm/app/stats/page/question-views/components/questions-custom/styles/Component.module.scss'
import { NO_PRINT } from '@aytm/app/stats/page/question-views/components/lib/constants'

export const DataContext = React.createContext()

const Component = ({ Controls, children, model, data, states, changed, disabled, ...props }) => {
  const [collapsed, setCollapsed] = useState(
    !states.error && states.loaded && (states.collapsed == undefined || states.collapsed)
  )

  const componentRef = useRef()

  const collapsedRef = useRef()
  collapsedRef.current = collapsed

  const onToggle = () => {
    setCollapsed(!collapsedRef.current)
  }

  // TODO
  useEffect(() => {
    states.collapsed != undefined && setCollapsed(states.collapsed)
  }, [states.collapsed])

  // A collapsed component opens itself only for an error it would otherwise be hiding -- the message
  // renders inside the panel. It deliberately does NOT open because the data went stale: an edit is
  // what makes it stale, so opening on that undoes the researcher's own collapse a moment after they
  // made it, on every field they touch. A surface that wants it open for any other reason -- a new
  // preset, a new group -- says so through `states.collapsed` above.
  useEffect(() => {
    collapsedRef.current && !changed && !states.loading && states.error && setCollapsed(false)
  }, [states.loading, states.error, changed])

  return (
    <div className={`${style.component} ${NO_PRINT}`}>
      <Controls model={model} data={data} collapsed={collapsed} disabled={disabled} onToggle={onToggle} {...props} />
      <TransitionPanel in={!collapsed}>
        {status =>
          'exited' === status ? null : (
            <div ref={componentRef} className={style['component-children']}>
              {children}
              {'string' == typeof states.error && (
                <div className={`${style.row} ${style['row-error']}`}>{states.error}</div>
              )}
            </div>
          )
        }
      </TransitionPanel>
    </div>
  )
}

Component.propTypes = {
  Controls: PropTypes.any,
  children: PropTypes.any,
  model: PropTypes.object,
  data: PropTypes.object,
  states: PropTypes.object,
  changed: PropTypes.bool,
  disabled: PropTypes.bool
}

Component.displayName = 'Component'

export default Component
